<template>
  <div class="select-startstop">
    <section class="title-bar">
      <div class="hero-body">
        <p class="title">作業量の入力</p>
        <p class="subtitle">送信する作業量を入力してください</p>
      </div>
    </section>

    <section>
      <b-field label="実績値を入力して、送信ボタンを押してください。">
        <form ref="form">
          <div class="input-amount">
            <b-numberinput
              v-model="inputNumber"
              placeholder="100"
              :min="0"
              max="99999"
              size="is-large"
              type="is-success"
            ></b-numberinput>
          </div>
        </form>
      </b-field>
      <b-button size="is-large" :disabled="isDisabled" @click="save_work_clicked">保存</b-button>
    </section>
    <b-loading
      :is-full-page="true"
      v-model="isLoading"
      :can-cancel="false"
      style="background-color: rgba(0, 0, 0, 0.8)"
    ></b-loading>
  </div>
</template>

<script>
import ApiService from '../services/ApiService';

export default {
  name: 'InputAmount',
  data: function () {
    return {
      inputNumber: 10,
      isLoading: false,
      isDisabled: false,
    };
  },
  watch: {
    inputNumber: function () {
      const valid = this.$refs.form.checkValidity();
      this.isDisabled = !valid;
    },
  },
  mounted() {
    if (
      !(this.$route.query.action == 'start' || this.$route.query.action == 'end') &&
      this.$route.query.pid
    ) {
      this.$buefy.dialog.alert({
        message: '不正な遷移です。最初からやり直してください。',
        onConfirm: () => {
          me.$router.push('/login');
        },
      });
    }
    this.action = this.$route.query.action;
    this.placeName = this.$route.query.pname;
    this.taskName = this.$route.query.tname;
    this.uid = this.$route.query.uid;
  },
  methods: {
    save_work_clicked: function () {
      this.$buefy.dialog.confirm({
        message: '作業終了を記録します',
        onConfirm: () => {
          this.save_work_record();
        },
      });
    },
    save_work_record: function () {
      const record = {
        worker_id: this.uid,
        task_name: this.taskName,
        result: this.inputNumber,
        working_area_name: this.placeName,
        record_type: this.action,
      };

      const apiService = new ApiService();
      const me = this;

      this.isLoading = true;

      apiService.saveWorkingRecord(record, (response) => {
        this.isLoading = false;
        if (response.status == 200) {
          this.$buefy.toast.open('作業の記録を行いました');
          setTimeout(() => {
            this.$router.push('/done');
          }, 1000);
        } else if (response.status == 401) {
          // トークン再取得失敗時にはログイン画面へ遷移
          me.$buefy.dialog.alert({
            message: 'ログインに失敗しました、管理者に再度ログインしてもらってください。',
            onConfirm: () => {
              me.$router.push('/admin_login');
            },
          });
        } else {
          this.$buefy.alert('作業記録の送信に失敗しました');
        }
      });
    },
  },
};
</script>
<style scoped>
section.title-bar {
  background-color: #008a75;
}
p.title {
  color: white;
}
p.subtitle {
  color: white;
}
.input-amount {
  padding: 0 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/InputAmount.vue